<template>
    <div class="flex flex-wrap gap-2">
        <div
            :class="[
                'flex gap-2 items-center transition-all shrink-0',
                variant === 'default'
                    ? ['backdrop-blur-sm p-2 rounded-full overflow-hidden group max-w-[32px] hover:max-w-max']
                    : variant === 'alwaysVisible'
                        ? ['backdrop-blur-sm p-2 rounded-full overflow-hidden max-w-max']
                        : '' // inline → no bg/padding
            ]"
        >
            <div
                :class="[
                    variant === 'inline' ? textColor : 'text-white'
                ]"
            >
                <svg-vue
                    :class="[
                        variant === 'alwaysVisible' || variant === 'inline' ? 'h-3.5' : 'h-4'
                    ]"
                    :icon="icon"
                />
            </div>
            <div
                :class="[
                    variant === 'default'
                        ? 'text-white text-[10px] opacity-0 transition group-hover:opacity-100 break-keep shrink-0'
                        : variant === 'alwaysVisible'
                            ? 'text-white text-[10px] break-keep shrink-0'
                            : textColor + ' text-[10px] break-keep shrink-0' // inline always visible
                ]"
            >
                {{ label }}
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'all'
        },
        variant: {
            type: String,
            default: 'default' // "default" | "alwaysVisible" | "inline"
        }
    },
    computed: {
        current() {
            const base = {
                must_see: { icon: 'camera', label: 'Must see', color: 'indigo-500' },
                food_and_drinks: { icon: 'food', label: 'Food and Drinks', color: 'amber-500' },
                shopping: { icon: 'shopping', label: 'Shopping', color: 'yellow-500' },
                amusement: { icon: 'amusement', label: 'Amusement', color: 'rose-500' },
                park: { icon: 'tree', label: 'Nature', color: 'green-500' },
                activity: { icon: 'sport', label: 'Activity', color: 'red-500' },
                services: { icon: 'info', label: 'Services', color: 'stone-500' },
                transportation: { icon: 'bus', label: 'Transportation', color: 'emerald-500' },
                parking: { icon: 'parking', label: 'Parking', color: 'blue-500' },
                all: { icon: 'show', label: 'All', color: 'gray-500' }
            }

            return base[this.type] || base.all
        },
        icon() {
            return this.current.icon
        },
        label() {
            return this.current.label
        },
        color() {
            if (this.variant === 'default') return `bg-${this.current.color}/40`
            if (this.variant === 'alwaysVisible') return `bg-${this.current.color}`
            return '' // inline has no background
        },
        textColor() {
            return `text-${this.current.color}`
        }
    }
}
</script>
